import * as types from './quartals.types';
export const quartalsPageSelectors: types.IQuartalPageSelectors = {
  selectQuartals: (state) => state.page.quartals.quartalsIds,
};
